import fetch from "auth/FetchInterceptor";
import axios from "axios";
import { API_BASE_URL } from "../configs/AppConfig";
const JwtAuthService = {};

JwtAuthService.login = function (data) {
  return fetch({
    url: "/login",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  }); /*
	return axios.post(API_BASE_URL+'/login',data)
		.then(response => {
			if (response.data.success === true){
				console.log(response.data);
			}

		})
		.catch(response => {
			console.log(response.message);
		})*/
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/register",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  });
};

JwtAuthService.logout = function (data) {
  return fetch({
    url: "/logout",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  });
};

export default JwtAuthService;
